import _ from 'lodash';
import PermissionsService from '@/common/services/user_permissions.service';

export default {
  data() {
    return {
      isAdmin: false,
      isViewer: false,
      isKioskAdmin: false,
      isKioskEditor: false,
      isKioskViewer: false,
      permissionLevel: 0,
      kioskId: null,
      id: null,
      permissionLogging: false,
    };
  },
  mounted() {
    this.initializePermissions();
  },
  methods: {
    initializePermissions() {
      // eslint-disable-next-line
      let kioskId = this.kioskId;
      if (kioskId === null) {
        kioskId = this.id;
      }
      this.isAdmin = PermissionsService.isAdmin();
      this.isViewer = PermissionsService.isViewerUser();
      // this.setPermissionLevel();
      this.setPermissions(kioskId);
    },
    /**
     * This sets off an gets the permissions
     * @param kioskId
     */
    setPermissions(kioskId) {
      this.permissionLog(`setPermissions: ${kioskId}`);
      if (kioskId) {
        this.checkPermissions(kioskId)
          .then((permissions) => {
            [this.isKioskAdmin, this.isKioskEditor, this.isKioskViewer] = permissions;
          })
          .then(() => {
            this.setPermissionLevel();
          });
      }
    },
    /**
     * Leave this empty, it's a callback
     */
    permissionCallback() {},
    /**
     * This fetches the permissions from the server
     * @param kioskId
     * @returns {Promise<[unknown, any, any, any]>}
     */
    checkPermissions(kioskId) {
      this.permissionLog(`checkPermissions: ${kioskId}`);
      const kioskAdminPromise = PermissionsService.isCurrKioskAdmin(kioskId);
      const kioskEditorPromise = PermissionsService.isCurrKioskEditor(kioskId);
      const kioskViewerPromise = PermissionsService.isCurrKioskViewer(kioskId);

      return Promise.all([kioskAdminPromise, kioskEditorPromise, kioskViewerPromise]);
    },
    setPermissionLevel() {
      // level 0 is can't
      // level 1 is Kiosk Viewer,
      // level 3 is Kiosk Editor,
      // level 5 is Kiosk Admin,
      // level 10 is admin
      if (this.isAdmin) {
        this.permissionLevel = 10;
      } else if (this.isViewer) {
        if (this.isKioskAdmin) {
          this.permissionLevel = 5;
        } else if (this.isKioskEditor) {
          this.permissionLevel = 3;
        } else if (this.isKioskViewer) {
          this.permissionLevel = 1;
        } else {
          this.permissionLevel = 0;
        }
      }
      this.permissionLog('setPermissionLevel', {
        permissionLevel: this.permissionLevel,
        isKioskViewer: this.isKioskViewer,
        isKioskEditor: this.isKioskEditor,
        isKioskAdmin: this.isKioskAdmin,
        isViewer: this.isViewer,
        isAdmin: this.isAdmin,
      });
      this.permissionCallback();
    },
    checkPermissionLevel(minLevel, userLevel = this.permissionLevel) {
      this.permissionLog(`checkPermissionLevel: ${userLevel}`);
      let isAllowed = false;
      if (userLevel >= minLevel) {
        isAllowed = true;
      }
      return isAllowed;
    },
    permissionLog(msg, data = null, visible = this.permissionLogging) {
      if (visible) {
        if (data) {
          console.log(msg, _.cloneDeep(data));
        } else {
          console.log(msg);
        }
      }
    },
  },
};
